import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/remove.svg
 */
const IconRemove: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M20.79 3.817a1.427 1.427 0 01-.005 2.02l-6.158 6.159 6.162 6.162a1.436 1.436 0 01.001 2.025l-.604.605a1.432 1.432 0 01-2.026 0l-6.162-6.163-6.159 6.16a1.426 1.426 0 01-1.556.313 1.428 1.428 0 01-.464-.31l-.605-.605a1.428 1.428 0 010-2.024L9.373 12 3.21 5.838a1.427 1.427 0 01.004-2.02l.604-.605a1.432 1.432 0 012.022-.004l6.161 6.162 6.158-6.158c.133-.133.29-.24.464-.312a1.434 1.434 0 011.097.001c.174.072.33.177.464.31l.604.605z"
      fill="currentColor"
    />
  </svg>
);

export default IconRemove;
